<script>
    import {
        health, energy, hygiene, culture,
        iq, loneliness, confidence, stress,
        honesty, optimism, fitness,
        ItemCategoryEnum
    } from './stores.js';
    import ItemsList from "./ItemsList.svelte";

    function getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    let currentShop = null;

    let enterShop = (category) => {
        console.log('enterShop');

        switch (category) {
            case ItemCategoryEnum.General:
                console.log(category);
                currentShop = ItemCategoryEnum.General;
                break
            case ItemCategoryEnum.Appliances:
                currentShop = ItemCategoryEnum.Appliances;
                break
            case ItemCategoryEnum.Books:
                currentShop = ItemCategoryEnum.Books;
                break
            case ItemCategoryEnum.Music:
                currentShop = ItemCategoryEnum.Music;
                break
            default:
                currentShop = null;
        }
    };

</script>

<style>
    div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: url("/img/shop.png") center no-repeat;
        background-size: cover;
        min-height: 900px;
        height: 90vh;
        max-height: 100vh;
    }
    h1 {
        position: absolute;
        top: 1em;
        font-size: 3rem;
        text-align: center;
    }
    categories {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: stretch;
    }
    sl-button {
        margin-bottom: 1em;
    }
</style>

<div>
    {#if currentShop === null}
        <h1>Shopping</h1>
        <categories>
            {#each Object.values(ItemCategoryEnum) as category}
                <sl-button size="large" on:click={() => enterShop(category)}>
                    {getKeyByValue(ItemCategoryEnum, category)}
                </sl-button>
            {/each}
        </categories>
    {:else}
        <h1>{getKeyByValue(ItemCategoryEnum, currentShop)} Section</h1>
        <ItemsList currentShop={currentShop} />
        <sl-button size="medium" on:click={() => enterShop(null)}>Back to shops</sl-button>
    {/if}
</div>
